import { render, staticRenderFns } from "./PickMenuList.vue?vue&type=template&id=09a24f69&"
import script from "./PickMenuList.vue?vue&type=script&lang=ts&"
export * from "./PickMenuList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports